import { render } from "./FloatingDots.vue?vue&type=template&id=fa4fb222"
import script from "./FloatingDots.vue?vue&type=script&lang=js"
export * from "./FloatingDots.vue?vue&type=script&lang=js"

import "./FloatingDots.vue?vue&type=style&index=0&id=fa4fb222&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__